// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style__wrapper__xENOx","count":"style__count__4Ef1Y","rightSection":"style__rightSection__SmsJi","button":"style__button__Wn2yp"};